import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modalWrapper"];
  static values = { autoOpen: { type: Boolean, default: false } };

  connect() {
    if (this.autoOpenValue) {
      this.showModal();
    }
  }

  showModal() {
    this.modalWrapperTarget.classList.remove("hidden");
  }

  hideModal() {
    if (this.autoOpenValue) return;

    this.modalWrapperTarget.classList.add("hidden");
  }

  closeOnBackdrop(event) {
    if (this.autoOpenValue) return;

    if (event.target === this.modalWrapperTarget) {
      this.hideModal();
    }
  }
}
